import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CyklusProduktEnumDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/cyklus-produkt-enum-dto';
import { CyklusProduktStatusEnumDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/cyklus-produkt-status-enum-dto';
import { KundeCyklusProduktDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-cyklus-produkt-dto';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';

@Component({
    selector: 'app-produkt-cyklus-icon',
    templateUrl: './produkt-cyklus-icon.component.html',
    styleUrls: ['./produkt-cyklus-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProduktCyklusIconComponent implements OnInit {
  @Input() produkt: CyklusProduktEnumDto;
  @Input() kunde: KundeDto;

  produktCyklus?: KundeCyklusProduktDto;
  icon: string;
  iconClass: string;
  tooltip: string;

  constructor() {}

  ngOnInit(): void {
    this.produktCyklus = this.kunde.kundeCyklusProdukter?.find((cyklysProdukt) => cyklysProdukt.cyklusProdukt == this.produkt);

    this.icon = this.getIcon();
    this.iconClass = this.getIconClass();
    this.tooltip = this.getTooltip();
  }

  getIcon(): string {
    switch (this.produkt) {
      case CyklusProduktEnumDto.Fyringsolie:
        return 'olie';
      case CyklusProduktEnumDto.Gas:
        return 'gas';
      case CyklusProduktEnumDto.El:
        return 'el';
    }
  }

  getIconClass(): string {
    if (this.produktCyklus == undefined) {
      return 'red';
    }

    if (this.produktCyklus.cyklusProduktStatus == undefined) {
      return 'orange';
    }

    if (this.IsActiveState()) {
      return 'green';
    }

    if (this.IsInactiveState()) {
      return 'red';
    }

    return '';
  }

  IsActiveState(): boolean {
    return (
      this.produktCyklus != undefined &&
      this.produktCyklus.cyklusProduktStatus != undefined &&
      (this.produktCyklus.cyklusProduktStatus == CyklusProduktStatusEnumDto.Aktiv ||
        this.produktCyklus.cyklusProduktStatus == CyklusProduktStatusEnumDto.KundePaaVej)
    );
  }

  IsInactiveState(): boolean {
    return (
      this.produktCyklus != undefined &&
      this.produktCyklus.cyklusProduktStatus != undefined &&
      this.produktCyklus.cyklusProduktStatus == CyklusProduktStatusEnumDto.Svigt
    );
  }

  getProduktText(): string {
    switch (this.produkt) {
      case CyklusProduktEnumDto.Fyringsolie:
        return 'fyringsolie';
      case CyklusProduktEnumDto.Gas:
        return 'gas';
      case CyklusProduktEnumDto.El:
        return 'el';
    }
  }

  getTooltip(): string {
    var produkt = this.getProduktText();

    var text = '';

    if (this.IsActiveState()) {
      var text = 'Kunden har ' + produkt;
    } else {
      var text = 'Kunden har ikke ' + produkt;
    }

    if (this.produktCyklus !== undefined && this.produktCyklus.statusTekst !== undefined) {
      text += '\r\nStatus: ' + this.produktCyklus.statusTekst;
    }

    return text;
  }
}
